<template>
  <div class="lua-icon">
    <Modal
      class="newModal"
      v-model="value"
     
      width="1000"
      :mask-closable="false"
      @on-cancel="clearModal"
      class-name="vertical-center-modal"
    >
      <div slot="header" class="icon-title">关联润滑点</div>
      <template v-if="!loading">
        <div class="u-flex">
          <div class="icon-left">
            <div class="table-text" v-if="isemit">已选</div>
            <div class="lua-table">
              <div class="lua-table-th">
                <div class="lua-table-th-lable" style="width: 7%" v-if="isemit">
                  选择
                </div>
                <div class="lua-table-th-lable" style="width: 30%">
                  润滑点名称
                </div>
                <div class="lua-table-th-lable" style="width: 63%">
                  装置型号
                </div>
                <!--<div class="lua-table-th-lable" style="width: 20%">标识符</div>
                <div class="lua-table-th-lable" style="width: 25%">
                  数据类型
                </div>
                <div class="lua-table-th-lable" style="width: 18%">
                  取值范围
                </div>
                <div class="lua-table-th-lable" style="width: 10%">单位</div> -->
              </div>
              <div
                class="lua-table-td"
                :class="{ 'lua-flex': sonmycomoption.length == 0 }"
              >
                <template v-if="sonmycomoption.length > 0">
                  <div
                    class="td-item"
                    v-for="(indx, key) in sonmycomoption"
                    :key="key"
                  >
                    <div
                      v-if="isemit"
                      class="lua-table-td-lable"
                      style="width: 7%"
                    >
                      <Checkbox v-model="indx.bo"></Checkbox>
                    </div>
                    <div class="lua-table-td-lable u-flex" style="width: 30%">
                      <div style="width: 100%" class="line-2">
                        {{ indx.oilSiteName }}
                      </div>
                    </div>
                    <div class="lua-table-td-lable" style="width: 63%">
                      <div style="width: 100%" class="line-2">
                        {{ indx.zhuangzhiName }}
                      </div>
                    </div>
                  </div>
                </template>
                <div v-else>暂无内容</div>
              </div>
            </div>
            <div class="check-len" v-if="isemit">
              <div class="u-flex">
                <Checkbox
                  @on-change="rightmeth"
                  :indeterminate="rightinder"
                  v-model="rightcheck.rightarraybo"
                ></Checkbox>
                <div class="check-len-font" style="">全选</div>
              </div>

              <div class="check-len-font" style="">
                已选择{{ rightcheck.rightlen }}项
              </div>
            </div>
          </div>
          <div v-if="isemit" class="arr-icons">
              <div
              class="arr-icon lua-cus"
              @click="addList()"
              :class="{ 'arr-icon-blue': leftcheck.btn }"
            >
              <Icon
                class="lua-icon"
                style="left: 1.5px"
                color="#ffffff"
                  type="ios-arrow-back"
              
              />
            </div>
            <div
              class="arr-icon lua-cus"
              style="margin-top: 4px;left:2px"
              @click="removeList()"
              :class="{ 'arr-icon-blue': rightcheck.btn }"
            >
              <Icon
                class="lua-icon"
                style="left: 0"
                color="#ffffff"
                type="ios-arrow-forward"
              />
            </div>
          
          </div>
          <div v-if="isemit" class="icon-right">
            <div class="table-text">候选</div>
            <div class="lua-table">
              <div class="lua-table-th">
                <div class="lua-table-th-lable" style="width: 7%">选择</div>

                <div class="lua-table-th-lable" style="width: 30%">
                  润滑点名称
                </div>
                <div class="lua-table-th-lable" style="width: 63%">
                  装置型号
                </div>
              </div>
              <div
                class="lua-table-td"
                :class="{ 'lua-flex': sonluaficonoption.length == 0 }"
              >
                <template v-if="sonluaficonoption.length > 0">
                  <div
                    class="td-item"
                    v-for="(indx, key) in sonluaficonoption"
                    :key="key"
                    v-show="indx.show"
                  >
                    <div class="lua-table-td-lable" style="width: 7%">
                      <Checkbox
                        v-model="indx.bo"
                        @on-change="(e) => determine(indx, e)"
                      ></Checkbox>
                    </div>
                    <div class="lua-table-td-lable u-flex" style="width: 30%">
                      <div style="width: 100%" class="line-2">
                        {{ indx.oilSiteName }}
                      </div>
                    </div>
                    <div class="lua-table-td-lable" style="width: 63%">
                      <div style="width: 100%" class="line-2">
                        {{ indx.zhuangzhiName }}
                      </div>
                    </div>
                  </div>
                </template>
                <div v-else>暂无内容</div>
              </div>
            </div>
            <div class="check-len">
              <div></div>

              <div class="check-len-font">已选择{{ leftcheck.leftlen }}项</div>
            </div>
          </div>
        </div>
        <div class="drawer-footer" slot="footer">
          <template v-if="isemit">
            <Button type="primary" @click="submit('formValidate')">提交</Button>
            <Button style="margin-left: 8px" @click="clearModal()">取消</Button>
          </template>
        </div>
      </template>
      <template v-else>
        <div style="height: 426px" class="u-flex u-row-center mw">
          <Spin />
        </div>
        <div class="drawer-footer" slot="footer"></div>
      </template>
      <div class="rh-model" v-if="timbo" @click="modelmehods"></div>
    </Modal>
  </div>
</template>
<script>
import { addType } from "@/api/knowledge/device";
import { listoilSite } from "@/api/knowledge/gateway.js";
export default {
  name: "luaIcoption",
  props: {
    clist: {},
    ficonoption: {
      type: Array,
    },
    isemit: {
      type: Boolean,
      default: true,
    },
    formDate: {},
    value: {},
    modelmehods: {},
    timbo: {},
  },
  data() {
    const valiidentifiers = (rule, value, callback) => {
      if (this.formData.identifiers.length > 0) {
        callback();
      } else {
        callback(new Error("请输入润滑点指标"));
      }
    };
    return {
      dataForm: {},
      showInDrawer: false,
      loading: true,
      sonluaficonoption: [],
      sonmycomoption: [],
      leftcheck: {
        leftarraybo: false,
        leftlen: 0,
        fiterar: [],
        btn: false,
      },
      rightcheck: {
        rightarraybo: false,
        rightlen: 0,
        fiterar: [],
        btn: false,
      },
      btnLoading: false,
      formData: {},
      ruleValidate: {
        name: [
          {
            required: true,
            message: "请填写名称",
            trigger: "blur",
          },
        ],
        series: [
          {
            required: true,
            message: "请选择装置",
            trigger: "blur",
          },
        ],
        identifiers: [{ validator: valiidentifiers, trigger: "blur" }],
      },
    };
  },
  computed: {
    leftinder() {
      const { fiterar } = this.leftcheck;
      let len = fiterar.length;
      let sonlength = this.sonluaficonoption.length;
      if (len == 0) {
        return false;
      } else if (len < sonlength) {
        return true;
      } else if (len == sonlength) {
        return false;
      }
    },
    rightinder() {
      const { fiterar } = this.rightcheck;
      let len = fiterar.length;
      let sonmycomoption = this.sonmycomoption.length;
      if (len == 0) {
        return false;
      } else if (len < sonmycomoption) {
        return true;
      } else if (len == sonmycomoption) {
        return false;
      }
    },
  },
  watch: {
    value: {
      handler: function (newValue, oldValue) {
        if (newValue) {
          this.getList(0);
        }
      },
    },
    // : {
    //   handler: function (newValue, oldValue) {
    //     this.rest();
    //     if (newValue) {
    //       this.sonluaficonoption = this.addjudgment(
    //         this.$c.deepClone(this.luaficonoption),
    //         "fat"
    //       );
    //       this.sonmycomoption = this.addjudgment(
    //         this.$c.deepClone(this.mycomoption),
    //         "son"
    //       );
    //     }

    //     this.$nextTick(() => {
    //       this.showInDrawer = newValue;
    //     });
    //   },
    //   deep: true,
    // },
    sonmycomoption: {
      deep: true,
      handler: function (arr) {
        let fiterar = arr.filter((e) => e.bo);
        let len = fiterar.length;
        this.rightcheck = {
          rightarraybo: len == this.sonmycomoption.length ? true : false,
          rightlen: len,
          fiterar: fiterar,
          btn: len == 0 ? false : true,
        };
        if (this.sonmycomoption.length == 0) {
          this.rightcheck.rightarraybo = false;
        }
      },
    },
    sonluaficonoption: {
      deep: true,
      handler: function (arr) {
        let fiterar = arr.filter((e) => e.bo);
        let len = fiterar.length;
        this.leftcheck = {
          leftarraybo: len == this.sonluaficonoption.length ? true : false,
          leftlen: len,
          fiterar: fiterar,
          btn: len == 0 ? false : true,
        };

        if (this.sonluaficonoption.length == 0) {
          this.leftcheck.leftarraybo = false;
        }
      },
    },
  },
  methods: {
    determine(row, bo) {
      // let
      let item = row;
      if (bo) {
        if (this.sonmycomoption.length > 0) {
          item = this.sonmycomoption[0];
        }

        this.sonluaficonoption = this.sonluaficonoption.map((item1) => {
          item1.show = false;

          if (item1.zhuangzhiId == item.zhuangzhiId) {
            item1.show = true;
          }
          return item1;
        });
      } else {
        if (this.sonmycomoption.length > 0) {
          return;
        } else {
          let iitem = this.sonluaficonoption.find((e) => e.bo);

          if (iitem) {
            return;
          } else {
            this.sonluaficonoption = this.sonluaficonoption.map((item1) => {
              item1.show = true;
              return item1;
            });
          }
        }
      }
    },
    clearModal() {
      this.$emit("input", false);
    },
    async getList(index = 1) {
      this.loading = true;
      const { data } = await listoilSite({ ...this.formDate });
      let { choosedOil, waitOil } = data;

      choosedOil = choosedOil.map((item) => {
        item.oilSiteIotName = item.oilSiteNumber;

        if (item.deviceConfigInfo) {
          let deviceInfo = item.deviceConfigInfo;
          item.IP = deviceInfo.IP;
          item.Port = deviceInfo.Port;
          item.SlaveId = deviceInfo.SlaveId;
          item.PollingPeriod = deviceInfo.PollingPeriod;
          item.DataBit = deviceInfo.DataBit;
          item.StopBit = deviceInfo.StopBit;
          item.Parity = deviceInfo.Parity;
          item.BaudRate = deviceInfo.BaudRate;
          item.SerialDevice = deviceInfo.SerialDevice;
          //  item.deviceInfo = deviceInfo;
        }
        return item;
      });

      waitOil = waitOil.map((item) => {
        item.oilSiteIotName = item.oilSiteNumber;
        if (item.deviceConfigInfo) {
          let deviceInfo = item.deviceConfigInfo;
          item.IP = deviceInfo.IP;
          item.Port = deviceInfo.Port;
          item.SlaveId = deviceInfo.SlaveId;
          item.PollingPeriod = deviceInfo.PollingPeriod;
          item.DataBit = deviceInfo.DataBit;
          item.StopBit = deviceInfo.StopBit;
          item.Parity = deviceInfo.Parity;
          item.BaudRate = deviceInfo.BaudRate;
          item.SerialDevice = deviceInfo.SerialDevice;
          // item.deviceInfo = deviceInfo;
        }
        return item;
      });
      let arr = [...waitOil, ...choosedOil];
      let list = this.clist;
      // const waitOil1=arr.filter(e=>{
      //    let item=list.find(e1=>e1.oilSiteId!==e.oilSiteId)
      //    if(item){
      //     return true
      //    }
      // })
      const choosedOil1 = arr.filter((e) => {
        //已选择的润滑点
        let item = list.find((e1) => e1.oilSiteId == e.oilSiteId);
        if (item) {
          return true;
        }
      });
      let waitOil1 = [];
      waitOil1 = arr.filter((item) => {
        let boitem = choosedOil1.find(
          (item1) => item1.oilSiteId == item.oilSiteId
        );
        return !boitem;
      });

      this.sonluaficonoption = this.addjudgment(
        //待选择的润滑点
        this.$c.deepClone(waitOil1),
        "fat"
      );

      this.sonmycomoption = this.addjudgment(
        // 选择了的润滑点
        this.$c.deepClone(choosedOil1),
        "son"
      );
      this.$nextTick(() => {
        this.indicate();
      });

      this.loading = false;
    },
    searchInput(val, name) {
      this.queryfrom[name] = val;
      this.getList(0);
    },
    rest() {
      this.formData = {
        name: "",
        series: "",
        remarks: "",
      };
    },
    rightmeth(value) {
      this.sonmycomoption = this.sonmycomoption.map((e) => {
        e.bo = value;
        return e;
      });
    },
    leftmeth(value) {
      this.sonluaficonoption = this.sonluaficonoption.map((e) => {
        e.bo = value;
        return e;
      });
    },
    indicate() {
      let sonluaficonoption = this.sonluaficonoption; //未选
      let sonmycomoption = this.sonmycomoption; //已选
      if (this.sonmycomoption.length == 0) {
        this.sonluaficonoption = this.sonluaficonoption.map((item) => {
          item.show = true;
          return item;
        });
      } else {
        let item = sonmycomoption[0];
        this.sonluaficonoption = this.sonluaficonoption.map((sitem) => {
          sitem.show = false;

          if (item.zhuangzhiId == sitem.zhuangzhiId) {
            sitem.show = true;
          }
          return sitem;
        });
      }
    },
    addList() {
      let { fiterar } = this.leftcheck;
      if (fiterar.length == 0) return;
      let sonmycomoption = this.sonmycomoption;
      sonmycomoption = [...this.sonmycomoption, ...fiterar];
      // sonluaficonoption
      this.sonmycomoption = sonmycomoption.map((item) => {
        item.bo = false;
        return item;
      });

      let sonluaficonoption = this.sonluaficonoption;

      sonluaficonoption = sonluaficonoption.filter((e) => {
        let bo = fiterar.find((myitem) => {
          if (myitem.oilSiteId == e.oilSiteId) {
            return true;
          }
        });
        return !bo;
      });

      this.sonluaficonoption = sonluaficonoption;
    },
    removeList() {
      let { fiterar } = this.rightcheck;

      if (fiterar.length == 0) return;

      let sonluaficonoption = this.sonluaficonoption;
      sonluaficonoption = [...fiterar, ...this.sonluaficonoption];

      this.sonluaficonoption = sonluaficonoption.map((item) => {
        item.bo = false;
        return item;
      });

      let sonmycomoption = this.sonmycomoption;
      sonmycomoption = sonmycomoption.filter((e) => {
        let bo = fiterar.find((myitem) => {
          if (myitem.oilSiteId == e.oilSiteId) {
            return true;
          }
        });
        return !bo;
      });
      this.sonmycomoption = sonmycomoption;
      this.$nextTick(() => {
        this.indicate();
      });
    },
    ok(res) {
      if (res.code === "00000") {
        this.$Message.success("提交成功");
      } else {
        this.$Message.info(res.msg);
      }
      this.btnLoading = false;
    },
    submit(name) {
      let songfaarr = this.sonmycomoption;

      this.$emit("change", { songfaarr });

      this.clearModal();
    },
    addjudgment(itemarr, msg) {
      return itemarr.map((item) => {
        item.bo = false;
        item.show = true;
        item.role = msg;
        return item;
      });
    },
  },
};
</script>
<style lang="less">
.luaIcon-drawer .ivu-modal-header,
.luaIcon-drawer .ivu-modal-footer {
  padding-left: 24px !important;
  border: none !important;
}

.luaIcon-drawer .ivu-modal-body {
  padding-left: 24px !important;
}
</style>
<style lang="less" scoped>
.icon-title {
  font-size: 16px;
  font-weight: 400;
  color: #111111;
}

.icon-left,
.icon-right {
  flex: 1;
}

.arr-icons {
  width: 16px;
  margin: 0 17px;

  .arr-icon-blue {
    background: rgba(33, 101, 193, 1) !important;
  }

  .arr-icon {
    width: 16px;
    height: 16px;
    background: rgba(210, 213, 217, 1);
    display: flex;
    align-items: center;
    justify-content: center;

    .lua-icon {
    
    }
  }
}

.table-text {
  font-size: 14px;
  margin-bottom: 8px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.851);
}

.lua-table {
  overflow-y: scroll;

  .lua-table-th {
    padding: 17px 20px;
    width: 100%;
    height: 50px;
    background: #f5f5f5;
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    font-weight: 400;
    color: #000000;
    z-index: 100;
    position: sticky;
    top: 0;

    .lua-table-th-lable {
      margin-right: 5px;
      text-align: left;
    }
  }

  .lua-table-td {
    padding: 0 20px;
    height: 268px;
    //   overflow: auto;

    .td-item {
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #ebebeb;
      box-sizing: border-box;

      .lua-table-td-lable {
        margin-right: 5px;
        text-align: left;
        font-size: 12px;
        height: 53px;
        font-weight: 400;
        color: #333333;
        display: flex;
        align-items: center;
        justify-content: center;
        display: flex;
        align-items: center;
      }
    }
  }
}

.check-len {
  width: 100%;
  padding: 0 21px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #ebebeb;

  &-font {
    font-size: 12px;

    font-weight: 400;
    color: #333333;
    margin-left: 18px;
  }
}

.lua-flex {
  display: flex;
  align-items: center;
  justify-content: center;
}

.lua-cus {
  cursor: pointer;
}
.input-lable {
  margin-right: 10px;
}
</style>